import React from "react";
import Components from "mpm-components";
import Services from "mpm-services";
import { Tab, Button, Icon, Divider } from "semantic-ui-react";

import Utilities from "mpm-config/Utilities";
import * as Constants from "mpm-config/Constants";
import StepRecap from "./sections/StepRecap";
import { CessionProduitView } from "mpm-classes/CessionProduit";
import { toClass } from "class-converter";
import PaneDetails from "./sections/PaneDetails";
import PaneSources from "./sections/PaneSources";
import MPMContext from "mpm-config/context/MPMContext";

export default (props) => {
  const context = React.useContext(MPMContext);
  const [currentAquereur, setCurrentAcquereur] = React.useState(null);
  const [cessionProduit, setCessionProduit] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [modalData, setModalData] = React.useState({ open: false });

  const [isPrinting, setIsPrinting] = React.useState(false);

  React.useEffect(() => {
    let param = props.selectedCessionProduitId;
    Services.CessionsProduitDataService.getForView(param)
      .then((response) => {
        let cession = toClass({ ...response.data }, CessionProduitView);
        setCessionProduit(cession);
        let acquereur = cession.entreposage
          ? cession.entrepotCPDTO
          : cession.acquereurCPDTO;
        setCurrentAcquereur(acquereur);
        setLoading(false);
      })
      .catch((err) => {
        props.setMessage({
          error: true,
          header: "Consultation Cession de Produit",
          content:
            "Une erreur est survenue lors de chargement de la cession de produit. veuillez réessayer ou contacter l'administrateur",
        });
        props.onComplet();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedCessionProduitId]);

  const onConfirmeCancelationCessionCapture = () => {
    setModalData({ ...modalData, loadingConfirm: true });
    Services.CessionsProduitDataService.confirmerAnnulation(cessionProduit)
      .then((response) => {
        if (response.success) {
          props.setMessage({
            success: true,
            header: "Confirmation d'annulation cession produit",
            content: "Opération effectuées avec succèes",
          });
          props.onComplet(true);
        } else {
          props.setMessage({
            warning: true,
            header: "Confirmation d'annulation de cession produit",
            content: response.message,
          });
          setModalData({ open: false });
        }
      })
      .catch((err) => {
        props.setMessage({
          error: true,
          header: "Confirmation d'annulation cession produit",
          content:
            "Une erreur est survenue lors de traitement de la cession de produit. veuillez réessayer ou contacter l'administrateur",
        });
        setModalData({ open: false });
      });
  };

  const onConfirmeDialog = (data) => {
    switch (data) {
      case "BUTTON_CONFIRMER_ANNULATION":
        onConfirmeCancelationCessionCapture();
        break;
      default:
        break;
    }
  };

  const onPrint = () => {
    setIsPrinting(true);
    Services.CessionsProduitDataService.printEtat({
      numeroCessionComplet: cessionProduit.numeroCessionComplet,
    })
      .then((response) => {
        if (response.success) {
          props.setMessage({
            success: true,
            header: "Impression d'etat",
            content: "Opération effectuées avec succèes",
          });

          setIsPrinting(false);
          Utilities.openBase64InNewTab(
            String(response.data),
            "application/pdf",
            cessionProduit.numeroCessionComplet
          );
        } else {
          props.setMessage({
            warning: true,
            header: "Impression d'etat",
            content: response.message,
          });
          setIsPrinting(false);
        }
      })
      .catch((err) => {
        props.setMessage({
          error: true,
          header: "Impression d'etat",
          content:
            "Une erreur est survenue lors de l'impression d'état. veuillez réessayer ou contacter l'administrateur",
        });
        setIsPrinting(false);
      });
  };

  return loading ? (
    <Components.MPMLoader
      message="chargement en cours, veuillez patienter !"
      hideLogo
    />
  ) : (
    <>
      <Tab
        panes={[
          {
            menuItem: "Cession de produit",
            render: () => (
              <Tab.Pane>
                <PaneDetails cessionProduit={cessionProduit} />
              </Tab.Pane>
            ),
          },
          {
            menuItem: "Type Source",
            render: () => (
              <Tab.Pane>
                <PaneSources cessionProduit={cessionProduit} />
              </Tab.Pane>
            ),
          },
          {
            menuItem: "Récapitulatif",
            render: () => (
              <Tab.Pane>
                <StepRecap cessionProduit={cessionProduit} isViewMode={true} />
              </Tab.Pane>
            ),
          },
        ]}
      />

      <Divider />
      <Button
        size="mini"
        icon
        className="full-width"
        labelPosition="left"
        onClick={() => props.onComplet()}
        disabled={isPrinting}
      >
        <Icon name="arrow left" />
        Retour
      </Button>
      {cessionProduit.etat === Constants.CC_ETAT_CONFIRMER && (
        <Button
          size="mini"
          floated="right"
          primary
          className="full-width"
          disabled={isPrinting}
          loading={isPrinting}
          icon
          labelPosition="left"
          onClick={() => onPrint()}
        >
          <Icon name="print" />
          Imprimer Etat
        </Button>
      )}
      {context.connectedUser?.login !== currentAquereur?.numeroAcquereur &&
        cessionProduit.etat ===
          Constants.CC_ETAT_EN_ATTETE_CONFIRMATION_ANNULATION && (
          <Button
            size="mini"
            floated="right"
            positive
            icon
            className="full-width"
            disabled={isPrinting}
            labelPosition="left"
            onClick={() =>
              setModalData({
                open: true,
                title: "Confirmation",
                content:
                  "Êtes vous sur de vouloir confirmer l'annulation de cette cession de produit ?",
                data: "BUTTON_CONFIRMER_ANNULATION",
              })
            }
          >
            <Icon name="close" />
            Confirmer l'annulation
          </Button>
        )}
      {modalData && (
        <Components.Modals.Confirmation
          modalData={modalData}
          onConfirm={(data) => onConfirmeDialog(data)}
          onCancel={() => setModalData({ open: false })}
        />
      )}
    </>
  );
};
